import { render } from "./Settings.vue?vue&type=template&id=5d296864"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render

export default script